export default __webpack_public_path__ + "static/media/05.a7661b35.png";